import { freeBusyCache, FreeBusyRow } from 'owa-freebusy-cache';
import { ObservableMap } from 'mobx';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';

/**
 * Initializes the Free Busy Cache
 */
export default function initFreeBusyCache(formId: string) {
    const viewState = getComposeViewState(formId);

    // Free Busy cache cannot be initialized twice, return if already initialized
    if (viewState.freeBusyData) {
        return;
    }

    let freeBusyData = (viewState.freeBusyData = new ObservableMap<
        string,
        ObservableMap<string, FreeBusyRow>
    >({}));

    freeBusyCache.initialize(freeBusyData);
}
